/* ==========================================================================
   IRON CREST LEATHER — product-card.js
   Colour swatches, wishlist, quick add and the cart drawer.

   The cart is Shopify's, not this file's: adds go to /cart/add.js, quantity
   changes to /cart/change.js, and the drawer re-renders from /cart.js. The
   server markup in snippets/overlays.liquid is the same shape this file writes,
   so first paint and every repaint agree.

   Add to bag is a real <form> submit underneath. This intercepts it only when
   fetch exists; if the script fails the browser posts the form and Shopify
   redirects to the cart, which is the correct fallback rather than a dead
   button.
   ========================================================================== */
(function () {
  'use strict';

  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var body = document.querySelector('[data-cart-body]');
  var empty = document.querySelector('[data-cart-empty]');
  var totalEl = document.querySelector('[data-cart-total]');
  var counts = document.querySelectorAll('[data-cart-count]');

  // Shopify quotes money in cents; the design shows whole units with a comma
  function money(cents) {
    var units = Math.round(cents) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency,
        minimumFractionDigits: units % 1 === 0 ? 0 : 2
      }).format(units);
    } catch (e) {
      return '$' + units.toLocaleString('en-US');
    }
  }

  /* ------------------------------------------------------------- rendering */
  function render(data) {
    if (!body || !data) return;

    Array.prototype.forEach.call(body.querySelectorAll('[data-line]'), function (n) { n.remove(); });

    (data.items || []).forEach(function (item) {
      var line = document.createElement('div');
      line.className = 'cart-line';
      line.setAttribute('data-line', item.key);
      line.innerHTML =
        '<div class="cart-line__media"><img src="' + (item.image || '') + '" alt="" loading="lazy"></div>' +
        '<div>' +
          '<p class="cart-line__t">' + item.product_title + '</p>' +
          '<p class="cart-line__v">' + (item.variant_title || '') + '</p>' +
          '<div class="cart-line__row">' +
            '<span class="qty">' +
              '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span>' + money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>';
      body.appendChild(line);
    });

    if (empty) empty.style.display = data.item_count ? 'none' : '';
    if (totalEl) totalEl.textContent = money(data.total_price || 0);
    Array.prototype.forEach.call(counts, function (c) {
      c.textContent = data.item_count;
      c.setAttribute('data-empty', data.item_count === 0 ? 'true' : 'false');
    });
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* ----------------------------------------------------------------- add */
  function addToCart(data) {
    var items = [{ id: data.id, quantity: Math.max(1, parseInt(data.qty, 10) || 1) }];
    // a chosen bundle tier is a second line, not a different price on the first
    if (data.bundle) items.push({ id: data.bundle, quantity: 1 });

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'add failed');
      return refresh();
    });
  }

  function changeLine(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(render);
  }

  /* ------------------------------------------------------------ delegation */
  document.addEventListener('click', function (e) {

    // quick add
    var add = e.target.closest('[data-add]');
    if (add) {
      // no fetch means no interception: let the real form post instead
      if (!window.fetch) return;
      e.preventDefault();
      var tier = document.querySelector('[data-tier]:checked');
      var label = add.textContent;
      addToCart({
        id: add.getAttribute('data-id'),
        qty: add.getAttribute('data-qty'),     // set by the product page stepper
        bundle: tier && tier.value ? tier.value : null
      }).catch(function (err) {
        add.textContent = 'Unavailable';
        if (window.console) console.warn('cart/add.js:', err.message);
        setTimeout(function () { add.textContent = label; }, 2000);
      });
      add.textContent = 'Added';
      add.setAttribute('data-state', 'added');
      setTimeout(function () {
        add.textContent = label;
        add.removeAttribute('data-state');
      }, 1600);
      if (window.IronCrestUI) window.IronCrestUI.open('cart');
      return;
    }

    // quantity
    var qty = e.target.closest('[data-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      var key = line.getAttribute('data-line');
      var delta = parseInt(qty.getAttribute('data-qty'), 10);
      var now = parseInt(line.querySelector('.qty span').textContent, 10) || 0;
      changeLine(key, Math.max(0, now + delta));
      return;
    }

    // wishlist
    var wish = e.target.closest('[data-wish]');
    if (wish) {
      e.preventDefault();
      var on = wish.getAttribute('aria-pressed') === 'true';
      wish.setAttribute('aria-pressed', on ? 'false' : 'true');
      wish.classList.toggle('is-on', !on);
      return;
    }

    // colour swatches
    var sw = e.target.closest('.swatch');
    if (sw) {
      e.preventDefault();
      var group = sw.parentNode;
      Array.prototype.forEach.call(group.querySelectorAll('.swatch'), function (s) {
        s.setAttribute('aria-pressed', 'false');
      });
      sw.setAttribute('aria-pressed', 'true');

      // Shopify: swap the card image + variant id from the variant's featured_image
      var card = sw.closest('.card');
      var addBtn = card && card.querySelector('[data-add]');
      if (addBtn) {
        var name = sw.getAttribute('aria-label') || '';
        var variant = addBtn.getAttribute('data-variant') || '';
        addBtn.setAttribute('data-variant', name + variant.slice(variant.indexOf(' · ')));
      }
    }
  });

  /* ------------------------------------------- collection tabs + show more */
  /* The tab row is built from the collections the products declare, so adding
     a product with a new collection adds a tab. In Liquid this becomes
     `{% for c in section.settings.collection_list %}` rendered server-side —
     see SHOPIFY.md section 4.

     Both the tabs and the button ship hidden and are revealed here, so a
     visitor without JavaScript gets the full grid and no dead controls. */
  (function () {
    var section = document.querySelector('[data-section-type="featured-collection"]');
    if (!section) return;

    var grid = section.querySelector('.product-grid');
    var wrap = section.querySelector('[data-tabs-wrap]');
    var list = section.querySelector('[data-tabs]');
    var indicator = section.querySelector('[data-tab-indicator]');
    var moreBtn = section.querySelector('[data-show-more]');
    if (!grid || !list) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    var PAGE = 8;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Server-rendered tabs win: a Liquid theme emits them from real collections,
    // and this script should only wire the behaviour. Otherwise derive the row
    // from what the products themselves declare.
    var tabs = Array.prototype.slice.call(list.querySelectorAll('.tab'));
    var keys;

    if (tabs.length) {
      keys = tabs.map(function (t) { return t.getAttribute('data-key'); });
    } else {
      keys = ['all'];
      cards.forEach(function (card) {
        (card.getAttribute('data-collections') || '').split(/\s+/).forEach(function (k) {
          if (k && keys.indexOf(k) === -1) keys.push(k);
        });
      });
      // one collection plus "all" is not a choice, so no tab row
      if (keys.length < 3) { if (moreBtn) wireMoreOnly(); return; }

      tabs = keys.map(function (key) {
        var b = document.createElement('button');
        b.className = 'tab';
        b.type = 'button';
        b.textContent = key === 'all' ? 'All' : key.charAt(0).toUpperCase() + key.slice(1);
        b.setAttribute('role', 'tab');
        b.setAttribute('data-key', key);
        b.setAttribute('aria-controls', 'best-grid');
        list.insertBefore(b, indicator);
        return b;
      });
    }

    tabs.forEach(function (t, i) {
      t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      t.tabIndex = i === 0 ? 0 : -1;          // roving tabindex
    });
    if (wrap) wrap.hidden = false;

    var current = 'all';
    var expanded = false;

    function inCollection(card, key) {
      if (key === 'all') return true;
      return (card.getAttribute('data-collections') || '').split(/\s+/).indexOf(key) !== -1;
    }
    function matching() {
      return cards.filter(function (c) { return inCollection(c, current); });
    }

    function paint() {
      var visible = matching();
      var limit = expanded ? visible.length : PAGE;
      var i = 0;
      cards.forEach(function (card) {
        var at = visible.indexOf(card);
        var show = at !== -1 && at < limit;
        card.setAttribute('data-filtered', show ? 'false' : 'true');
        if (show) {
          card.style.setProperty('--i', i++);
          // a card hidden at load never intersects, so the reveal observer
          // would leave it at opacity 0 when the filter brings it back
          card.classList.add('is-in');
        }
      });
      if (moreBtn) {
        moreBtn.hidden = expanded || visible.length <= PAGE;
        moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function moveIndicator() {
      var active = tabs[keys.indexOf(current)];
      if (!active || !indicator) return;
      var lb = list.getBoundingClientRect();
      var ab = active.getBoundingClientRect();
      indicator.style.transform =
        'translateX(' + (ab.left - lb.left + list.scrollLeft) + 'px) scaleX(' + ab.width + ')';
    }

    function animateIn() {
      if (reduced.matches) return;
      section.removeAttribute('data-entering');
      void grid.offsetWidth;                  // restart the keyframes
      section.setAttribute('data-entering', 'true');
    }

    function select(key, moveFocus) {
      if (key === current) return;
      current = key;
      expanded = false;

      tabs.forEach(function (t) {
        var on = t.getAttribute('data-key') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (!on) return;
        if (moveFocus) t.focus();
        t.scrollIntoView({ block: 'nearest', inline: 'center',
                           behavior: reduced.matches ? 'auto' : 'smooth' });
      });
      moveIndicator();

      if (reduced.matches) { paint(); return; }
      section.setAttribute('data-filtering', 'true');
      setTimeout(function () {
        paint();
        section.setAttribute('data-filtering', 'false');
        animateIn();
      }, 200);
    }

    list.addEventListener('click', function (e) {
      var t = e.target.closest('.tab');
      if (t) select(t.getAttribute('data-key'), false);
    });

    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i === -1) return;
      var n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      select(tabs[n].getAttribute('data-key'), true);
    });

    function wireMoreOnly() {
      moreBtn.addEventListener('click', reveal);
      paint();
    }
    function reveal() {
      var before = matching();
      expanded = true;
      paint();
      animateIn();
      var first = before[PAGE] && before[PAGE].querySelector('.card__title a');
      if (first) first.focus();
    }
    if (moreBtn) moreBtn.addEventListener('click', reveal);

    paint();
    requestAnimationFrame(moveIndicator);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(moveIndicator, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveIndicator);
  })();

  /* The drawer is rendered by Liquid from cart.items, so it is already correct
     when the page arrives. render() is for repainting it after a change — and
     it clears every [data-line] before it draws, so calling it here with no
     cart wiped the server-rendered lines on every page load. */
})();
